import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {textMetadata} from '../../../../../utils/builderMetadata'

export type TextsSettingsParams = {
  titleText: SettingsParamType.Text
  titleRequestText: SettingsParamType.Text
  descriptionText: SettingsParamType.Text
  descriptionRequestText: SettingsParamType.Text
  buttonLabelText: SettingsParamType.Text
  buttonLabelRequestText: SettingsParamType.Text
}

export const textsSettingsParams = createSettingsParams<TextsSettingsParams>({
  titleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservations.title'),
    metadata: textMetadata(
      'uou-reservations.reservations.title',
      'Page title when reservations are confirmed instantly',
    ),
  },
  titleRequestText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservations.title.request'),
    metadata: textMetadata(
      'uou-reservations.reservations.title.request',
      'Page title when reservations are requests that need approval',
    ),
  },
  descriptionText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservations.subtitle'),
    metadata: textMetadata(
      'uou-reservations.reservations.subtitle',
      'Description under the title when reservations are confirmed instantly',
    ),
  },
  descriptionRequestText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservations.subtitle.request'),
    metadata: textMetadata(
      'uou-reservations.reservations.subtitle.request',
      'Description under the title when reservations are requests that need approval',
    ),
  },
  buttonLabelText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservations.continue-cta'),
    metadata: textMetadata(
      'uou-reservations.reservations.continue-cta',
      'Text on the continue button when reservations are confirmed instantly',
    ),
  },
  buttonLabelRequestText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservations.continue-cta.request'),
    metadata: textMetadata(
      'uou-reservations.reservations.continue-cta.request',
      'Text on the continue button when reservations are requests that need approval',
    ),
  },
})
